import { toast } from '@zerodevx/svelte-toast';
import NotificationToast from '$lib/components/common/toasts/NotificationToast.svelte';
import { getAuthUser } from './auth.util';
import { removeFcmToken } from './api/user.util';
import { firebaseMessagingToken } from '$stores/firebase.store';
import { get } from 'svelte/store';

export const handleFcmNotification = async data => {
  let me = getAuthUser(false);

  if (me._id == data.owner) {
    toast.push({
      component: {
        src: NotificationToast as any,
        props: {
          title: data.title,
          type: data.type
        },
        sendIdTo: 'toastId'
      },
      duration: 5000,
      dismissable: false
    });
  } else {
    await removeFcmToken(get(firebaseMessagingToken));
  }
};
